export const currencySymbols = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  TRY: "₺",
  // Diğer para birimleri
};
